import React, { useCallback, useMemo } from 'react';
import { ReactComponent as CalendarIcon } from 'app/assets/img/icon_datepicker.svg';
import { Col, Collapse, Row } from 'antd';
import useWindowSize from 'app/hooks/useWindowSize';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';
import {
  CancelOrderComponent,
  Countdown,
  TicketType,
} from 'app/pages/NewAccount/layouts/ListTicketLayout';
import {
  I_DetailTicket,
  I_Paginator,
  I_PayloadGetListOrder,
} from 'app/pages/Account/ListOrder/slice/types';
import { LoadingOutlined } from '@ant-design/icons';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { BP_TYPE, TYPE_LOCAL_STORAGE } from 'utils/constants';
import { setSessionItem } from 'utils/localStorage';
import TicketInfoTitle from '../components/TicketInfoTitle';
import ColTicketInfo from '../components/ColTicketInfo';
import StyledDivider from '../components/StyledDivider';
import moment from 'moment';
import { clickToDownload, formatNumber, windowOpenLink } from 'utils/helper';
import StyledButton from 'app/components/StyledButton';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';
import styled from 'styled-components';
import { Permission } from 'app/hooks/usePermission';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
export const listType = translations => {
  return [
    {
      value: 1,
      label: translations ? translations['b2b.text.intra-province-ticket'] : '',
    },
    {
      value: 2,
      label: translations
        ? translations['b2b.text.out-of-province-ticket']
        : '',
    },
    {
      value: 4,
      label: translations ? translations['b2b.text.s4-ticket'] : '',
    },
  ];
};
export const listObject = translations => {
  return [
    {
      value: 1,
      label: translations ? translations['b2b.text.adult-ticket'] : '',
    },
    {
      value: 2,
      label: translations ? translations['b2b.text.child-ticket'] : '',
    },
    {
      value: 4,
      label: translations ? translations['b2b.text.senior-ticket'] : '',
    },
    {
      value: 6,
      label: translations ? translations['b2b.txt.u25-ticket'] : '',
    },
  ];
};
export const CustomInput: React.FC<{
  value?: string | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  placeholder?: string;
  className?: string;
  onChange?: (value: string) => void;
}> = ({ value, onClick, placeholder, onChange, className }) => (
  <div
    onClick={onClick}
    style={{ fontFamily: 'Be Vietnam Pro, sans-serif' }}
    className={className}
  >
    <input
      type="text"
      style={{
        height: '30px',
        border: 'none',
        borderWidth: 0,
        outline: 'none',
        width: '100%',
        fontFamily: 'inherit',
        fontWeight: 400,
      }}
      defaultValue={value}
      value={value}
      placeholder={placeholder}
      autoComplete="off"
      onChange={e => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
    />
    <CalendarIcon
      style={{ position: 'absolute', right: 5, top: 5, flexShrink: 0 }}
    />
  </div>
);

export const OrderInfoExchangeView = ({
  ticket,
  formatString,
  setIsCreatingPayment,
  isShowButtonPay,
  isCreatingPayment,
  search,
  isAbleCancelOrder,
  onCancelOrderSuccess,
}: {
  ticket: TicketType;
  formatString: string;
  isShowButtonPay?: boolean;
  setIsCreatingPayment?: (isCreating: boolean) => void;
  isCreatingPayment?: boolean;
  search?: (payload: Partial<I_PayloadGetListOrder>) => void;
  isAbleCancelOrder?: boolean;
  onCancelOrderSuccess?: () => void;
}) => {
  const { Panel } = Collapse;
  const { device } = useWindowSize();
  const history = useHistory();
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const antIcon = useMemo(
    () => <LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />,
    [],
  );
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const isProxyOrder = !!(ticket as any)?.emailBpAllocatedDebt;

  const payOrder = useCallback(async () => {
    try {
      setIsCreatingPayment?.(true);
      // setSessionItem(TYPE_LOCAL_STORAGE.ORDER, JSON.stringify(ticket._id));
      history.push('/checkout/' + ticket._id);
    } catch (e) {
    } finally {
      setIsCreatingPayment?.(false);
    }
  }, [history, setIsCreatingPayment, ticket._id]);

  return (
    <Row
      gutter={device === 'mobile' ? 0 : 37}
      style={{ marginBottom: device === 'mobile' ? 0 : 12 }}
    >
      <Col span={device !== 'mobile' ? 12 : 24}>
        {device === 'mobile' && (
          <>
            <StyledCollapse defaultActiveKey="1">
              <CollapsePanelWrapper
                key={'1'}
                header={
                  <div className="d-flex">
                    <TicketInfoTitle
                      className="ticket-info-title"
                      style={{ fontSize: 16 }}
                    >
                      {translations ? translations['b2c.txt.info-order'] : ''}
                    </TicketInfoTitle>
                    <div
                      style={{
                        padding: '4px 8px',
                        whiteSpace: 'nowrap',
                        background: '#F54949',
                        borderRadius: '8px',
                        color: 'white',
                        height: '25px',
                        fontSize: '12px',
                        marginLeft: 20,
                      }}
                    >
                      {
                        translations?.[
                          `${
                            ticket?.isLongTerm
                              ? 'b2b.txt.long-term'
                              : 'b2b.txt.short-term'
                          }`
                        ]
                      }
                    </div>
                  </div>
                }
              >
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations ? translations['b2c.txt.orderNumber'] : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                    {ticket.orderInfo.orderId}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations ? translations['b2c.txt.ticketAmount'] : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                    {ticket.orderInfo.amountOfTicket}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations
                      ? translations['b2b.txt.exchange-order-date']
                      : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                    {moment(ticket.orderInfo.orderDate, formatString).format(
                      'DD/MM/YYYY',
                    )}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations
                      ? translations['b2b.upgrade.refund-amount']
                      : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue
                    style={{
                      paddingLeft: 8,
                      color: '#E92127',
                    }}
                  >
                    {formatNumber(ticket?.refundAmount || 0)}
                    {'đ'}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations
                      ? translations['b2b.upgrade.total-new-order']
                      : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue
                    style={{
                      paddingLeft: 8,
                      color: '#E92127',
                    }}
                  >
                    {formatNumber(
                      ticket?.orderInfo?.totalPriceValue +
                        (ticket?.refundAmount || 0),
                    )}
                    {'đ'}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations ? translations['b2b.upgrade.discount'] : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue
                    style={{
                      paddingLeft: 8,
                      color: '#F8B117',
                    }}
                  >
                    {formatNumber(ticket?.orderInfo?.totalDiscountValue || 0)}
                    {'đ'}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <Divider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations
                      ? translations['b2b.txt.total-difference']
                      : ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue
                    style={{
                      paddingLeft: 8,
                      color: '#E92127',
                    }}
                  >
                    {formatNumber(ticket?.differenceAmount || 0)}
                    {'đ'}
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
                <StyledDivider dashed style={{ marginBottom: 0 }} />
              </CollapsePanelWrapper>
            </StyledCollapse>
            <StyledCollapse defaultActiveKey="1">
              <CollapsePanelWrapper
                key={'1'}
                header={
                  <TicketInfoTitle
                    className="ticket-info-title"
                    style={{ fontSize: 16 }}
                  >
                    {translations ? translations['b2b.table.payment'] : ''}
                  </TicketInfoTitle>
                }
                collapseContentBoxCSS={{
                  paddingBottom: '0 !important',
                }}
              >
                <span style={{ color: '#000000', fontSize: 14 }}>
                  {ticket.orderInfo.payment?.name ?? ''}
                </span>
                <StyledDivider dashed style={{ marginTop: 18 }} />
              </CollapsePanelWrapper>
            </StyledCollapse>
            {!!ticket?.representativesInfo?.length && (
              <>
                <StyledCollapse defaultActiveKey="1">
                  <CollapsePanelWrapper
                    key={'1'}
                    header={
                      <TicketInfoTitle
                        className="ticket-info-title"
                        style={{ fontSize: 16 }}
                      >
                        {translations
                          ? translations['b2b.txt.representiveInfo']
                          : ''}
                      </TicketInfoTitle>
                    }
                    collapseContentBoxCSS={{
                      paddingBottom: '0 !important',
                    }}
                  >
                    {ticket?.representativesInfo?.map((item, index, arr) => (
                      <div
                        style={{
                          marginBottom: index === arr.length - 1 ? 20 : 0,
                        }}
                      >
                        <TicketInfoTitle
                          className="ticket-info-title"
                          style={{
                            marginBottom: 16,
                            marginTop: 16,
                            fontSize: '14px',
                          }}
                        >
                          {translations
                            ? translations['b2b.txt.agent-referrer'] +
                              ' ' +
                              (index + 1)
                            : ''}
                        </TicketInfoTitle>
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey>
                            {translations
                              ? translations['b2b.form.namePlaceholder']
                              : ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue
                            style={{
                              paddingLeft: 8,
                            }}
                          >
                            {item?.name}
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                        <StyledDivider dashed />
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey>
                            {translations ? translations['b2b.acc.phone'] : ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue
                            style={{
                              paddingLeft: 8,
                            }}
                          >
                            {item?.phone}
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                        <StyledDivider dashed />
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey>
                            {translations ? translations['b2b.acc.email'] : ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue
                            style={{
                              paddingLeft: 8,
                            }}
                          >
                            {item?.email}
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                        <StyledDivider dashed />
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey
                            style={{ paddingRight: 9 }}
                          >
                            {translations
                              ? translations['b2b.txt.position']
                              : ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue
                            style={{
                              paddingLeft: 8,
                            }}
                          >
                            {translations?.['b2b.txt.' + item?.position]}
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                      </div>
                    ))}
                  </CollapsePanelWrapper>
                </StyledCollapse>
              </>
            )}
          </>
        )}
        {(device === 'desktop' || device === 'tablet') && (
          <>
            <Row style={{ width: '100%' }}>
              <TicketInfoTitle
                className="ticket-info-title"
                style={{
                  marginBottom: 24,
                  fontSize: 16,
                }}
              >
                {translations ? translations['b2c.txt.info-order'] : ''}
              </TicketInfoTitle>
              <div
                style={{
                  padding: '4px 8px',
                  whiteSpace: 'nowrap',
                  background: '#F54949',
                  borderRadius: '8px',
                  color: 'white',
                  height: '25px',
                  fontSize: '12px',
                  marginLeft: 'auto',
                }}
              >
                {
                  translations?.[
                    `${
                      ticket?.isLongTerm
                        ? 'b2b.txt.long-term'
                        : 'b2b.txt.short-term'
                    }`
                  ]
                }
              </div>
            </Row>
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations ? translations['b2c.txt.orderNumber'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
                span={12}
              >
                {ticket.orderInfo.orderId}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations ? translations['b2c.txt.ticketAmount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
                span={12}
              >
                {ticket.orderInfo.amountOfTicket}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations
                  ? translations['b2b.txt.exchange-order-date']
                  : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
                span={12}
              >
                {moment(ticket.orderInfo.orderDate, formatString).format(
                  'DD/MM/YYYY',
                )}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations ? translations['b2b.upgrade.refund-amount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                  color: '#E92127',
                }}
                span={12}
              >
                {formatNumber(ticket?.refundAmount || 0)}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations
                  ? translations['b2b.upgrade.total-new-order']
                  : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                  color: '#E92127',
                }}
                span={12}
              >
                {formatNumber(
                  ticket?.orderInfo?.totalPriceValue +
                    (ticket?.refundAmount || 0),
                )}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations ? translations['b2b.upgrade.discount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                  color: '#F8B117',
                }}
                span={12}
              >
                {formatNumber(ticket?.orderInfo?.totalDiscountValue || 0)}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={12}>
                {translations ? translations['b2b.txt.total-difference'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                  color: '#E92127',
                }}
                span={12}
              >
                {formatNumber(ticket?.differenceAmount || 0)}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
          </>
        )}
        {(device === 'desktop' || device === 'tablet') &&
          !!ticket?.representativesInfo?.length && (
            <>
              <TicketInfoTitle
                className="ticket-info-title"
                style={{
                  marginTop: 32,
                }}
              >
                {translations ? translations['b2b.txt.representiveInfo'] : ''}
              </TicketInfoTitle>
              {ticket?.representativesInfo?.map((item, index) => (
                <div>
                  <TicketInfoTitle
                    className="ticket-info-title"
                    style={{
                      marginBottom: 16,
                      marginTop: 16,
                      fontSize: '14px',
                    }}
                  >
                    {translations
                      ? translations['b2b.txt.agent-referrer'] +
                        ' ' +
                        (index + 1)
                      : ''}
                  </TicketInfoTitle>
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations
                        ? translations['b2b.form.namePlaceholder']
                        : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue
                      style={{
                        paddingLeft: 8,
                      }}
                    >
                      {item?.name}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.phone'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue
                      style={{
                        paddingLeft: 8,
                      }}
                    >
                      {item?.phone}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.email'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue
                      style={{
                        paddingLeft: 8,
                      }}
                    >
                      {item?.email}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey style={{ paddingRight: 9 }}>
                      {translations ? translations['b2b.txt.position'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue
                      style={{
                        paddingLeft: 8,
                      }}
                    >
                      {translations?.['b2b.txt.' + item?.position]}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                </div>
              ))}
            </>
          )}
      </Col>
      <Col span={device !== 'mobile' ? 12 : 24}>
        {device === 'mobile' && (
          <StyledCollapse defaultActiveKey="1">
            <CollapsePanelWrapper
              key={'1'}
              header={
                <TicketInfoTitle
                  className="ticket-info-title"
                  style={{ fontSize: 16 }}
                >
                  {translations
                    ? translations[
                        isProxyOrder && !isProxyBuyer
                          ? 'b2b.txt.saleSupportInfo'
                          : 'b2c.txt.info-pay'
                      ] ?? 'Thông tin hỗ trợ bán hàng'
                    : ''}
                </TicketInfoTitle>
              }
            >
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.customer'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {ticket.paymentInfo.customerName}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <Divider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.phone'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {ticket.paymentInfo.phoneNumber}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <Divider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  Email
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  <div
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {ticket.paymentInfo.email}
                  </div>
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <Divider dashed />
            </CollapsePanelWrapper>
          </StyledCollapse>
        )}

        {isShowButtonPay && !isProxyOrder && (
          <>
            <Row>
              <Col
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <StyledButton
                  style={{
                    height: 44,
                    minWidth: 161,
                    marginRight: 8,
                  }}
                  textColor="white"
                  width={'auto'}
                  onClick={payOrder}
                >
                  {translations?.['b2b.txt.pay-now'] ?? ''}
                </StyledButton>
                <div>
                  {ticket.orderInfo.payment?.code !== 'BankTransfer' && (
                    <Countdown
                      onTimeout={() => search?.({})}
                      orderCheckout={ticket}
                    />
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <StyledButton
                  style={{
                    marginTop: 8,
                    height: 44,
                    minWidth: 161,
                  }}
                  onClick={() =>
                    windowOpenLink({
                      url: `/update-order-info?order_id=${ticket._id}`,
                      target: '_self',
                    })
                  }
                  textColor="white"
                  width={'auto'}
                >
                  {translations?.['b2b.txt.input-customer-info'] ?? ''}
                </StyledButton>
              </Col>
            </Row>
          </>
        )}

        {device === 'mobile' && isProxyOrder && (
          <>
            {isProxyOrder && isProxyBuyer && (
              <StyledCollapse defaultActiveKey="1">
                <CollapsePanelWrapper
                  key={'1'}
                  header={
                    <TicketInfoTitle
                      className="ticket-info-title"
                      style={{
                        fontSize: 16,
                      }}
                    >
                      {translations ? translations['b2b.txt.partnerInfo'] : ''}
                    </TicketInfoTitle>
                  }
                >
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.txt.partnerName'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      {(ticket as any)?.businessPartnerAllocatedDebt?.name}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.address'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      {(ticket as any)?.businessPartnerAllocatedDebt?.address}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.email'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      <TooltipParagraph
                        ellipsis={{ rows: 2 }}
                        style={{
                          marginBottom: 0,
                          textAlign: 'left',
                        }}
                      >
                        {
                          (ticket as any)?.businessPartnerAllocatedDebt
                            ?.emailAgent
                        }
                      </TooltipParagraph>
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                </CollapsePanelWrapper>
              </StyledCollapse>
            )}

            <StyledCollapse defaultActiveKey="1">
              <CollapsePanelWrapper
                key={'1'}
                header={
                  <TicketInfoTitle
                    className="ticket-info-title"
                    style={{
                      fontSize: 16,
                    }}
                  >
                    {translations
                      ? translations['b2b.txt.ticketRecipientInfo']
                      : ''}
                  </TicketInfoTitle>
                }
              >
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    Email
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue>
                    <TooltipParagraph
                      ellipsis={{ rows: 2 }}
                      style={{
                        marginBottom: 0,
                        textAlign: 'left',
                      }}
                    >
                      {(ticket as any)?.emailBpAllocatedDebt}
                    </TooltipParagraph>
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>

                {!!(ticket as any)?.approvedCode && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations?.['b2b.txt.approvalCode'] ?? ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                          }}
                        >
                          {(ticket as any)?.approvedCode}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}

                {!!(ticket as any)?.approveAttach && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations?.['b2b.txt.approvalDoc'] ?? ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                            color: '#f8b117',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={clickToDownload.bind(
                            null,
                            (ticket as any)?.approveAttach,
                          )}
                        >
                          {(ticket as any)?.approveAttach}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}

                <StyledDivider dashed />
              </CollapsePanelWrapper>
            </StyledCollapse>
          </>
        )}

        {isShowButtonPay && isProxyOrder && (
          <div style={{ marginBottom: 20 }}>
            <Row>
              <Col
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <StyledButton
                  style={{
                    height: 44,
                    minWidth: 161,
                    marginRight: 8,
                  }}
                  textColor="white"
                  width={'auto'}
                  onClick={payOrder}
                >
                  {translations?.['b2b.txt.pay-now'] ?? ''}
                </StyledButton>
                <div>
                  {ticket.orderInfo.payment?.code !== 'BankTransfer' && (
                    <Countdown
                      onTimeout={() => search?.({})}
                      orderCheckout={ticket}
                    />
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <StyledButton
                  style={{
                    marginTop: 8,
                    height: 44,
                    minWidth: 161,
                  }}
                  onClick={() =>
                    windowOpenLink({
                      url: `/update-order-info?order_id=${ticket._id}`,
                      target: '_self',
                    })
                  }
                  textColor="white"
                  width={'auto'}
                >
                  {translations?.['b2b.txt.input-customer-info'] ?? ''}
                </StyledButton>
              </Col>
            </Row>
          </div>
        )}

        {(device === 'desktop' || device === 'tablet') && (
          <>
            {/* payment method */}
            <TicketInfoTitle
              style={{
                marginBottom: 24,
                fontSize: 16,
              }}
            >
              {translations ? translations['b2b.table.payment'] : ''}
            </TicketInfoTitle>
            <Row>
              <ColTicketInfo.ColTicketInfoValue
                style={
                  {
                    // paddingLeft: 8,
                  }
                }
              >
                {ticket.orderInfo.payment?.name ?? ''}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider style={{ marginBottom: 36 }} dashed />

            {/* info payment */}
            <TicketInfoTitle
              style={{
                marginBottom: 24,
                fontSize: 16,
              }}
            >
              {translations
                ? translations[
                    isProxyOrder && !isProxyBuyer
                      ? 'b2b.txt.saleSupportInfo'
                      : 'b2c.txt.info-pay'
                  ] ?? 'Thông tin hỗ trợ bán hàng'
                : ''}
            </TicketInfoTitle>
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={9}>
                {translations ? translations['b2c.txt.customer'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue span={15}>
                {ticket.paymentInfo.customerName}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={9}>
                {translations ? translations['b2c.txt.phone'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue span={15}>
                {ticket.paymentInfo.phoneNumber}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey span={9}>
                Email
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue span={15}>
                <div
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {ticket.paymentInfo.email}
                </div>
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <Divider dashed />

            {isProxyOrder && (
              <div style={{ marginBottom: 20 }}>
                <div
                  className={`${
                    isProxyOrder && !isProxyBuyer ? 'd-none' : 'd-block'
                  }`}
                >
                  <TicketInfoTitle
                    style={{
                      marginBottom: 16,
                      marginTop: 32,
                    }}
                  >
                    {translations ? translations['b2b.txt.partnerInfo'] : ''}
                  </TicketInfoTitle>
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.txt.partnerName'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      {(ticket as any)?.businessPartnerAllocatedDebt?.name}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.address'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      {(ticket as any)?.businessPartnerAllocatedDebt?.address}
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                  <Row>
                    <ColTicketInfo.ColTicketInfoKey>
                      {translations ? translations['b2b.acc.email'] : ''}
                    </ColTicketInfo.ColTicketInfoKey>
                    <ColTicketInfo.ColTicketInfoValue>
                      <TooltipParagraph
                        ellipsis={{ rows: 2 }}
                        style={{
                          marginBottom: 0,
                          textAlign: 'left',
                        }}
                      >
                        {
                          (ticket as any)?.businessPartnerAllocatedDebt
                            ?.emailAgent
                        }
                      </TooltipParagraph>
                    </ColTicketInfo.ColTicketInfoValue>
                  </Row>
                  <StyledDivider dashed />
                </div>

                <TicketInfoTitle
                  style={{
                    marginBottom: 16,
                    marginTop: 32,
                  }}
                >
                  {translations
                    ? translations['b2b.txt.ticketRecipientInfo']
                    : ''}
                </TicketInfoTitle>
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    Email
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue>
                    <TooltipParagraph
                      ellipsis={{ rows: 2 }}
                      style={{
                        marginBottom: 0,
                        textAlign: 'left',
                      }}
                    >
                      {(ticket as any)?.emailBpAllocatedDebt}
                    </TooltipParagraph>
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>

                {!!(ticket as any)?.approvedCode && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations?.['b2b.txt.approvalCode'] ?? ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                          }}
                        >
                          {(ticket as any)?.approvedCode}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}

                {!!(ticket as any)?.approveAttach && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations?.['b2b.txt.approvalDoc'] ?? ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                            color: '#f8b117',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={clickToDownload.bind(
                            null,
                            (ticket as any)?.approveAttach,
                          )}
                        >
                          {(ticket as any)?.approveAttach}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}
              </div>
            )}

            {isShowButtonPay && (
              <>
                <Row>
                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <StyledButton
                      style={{
                        height: 44,
                        minWidth: 171,
                        marginRight: 8,
                      }}
                      onClick={payOrder}
                      textColor="white"
                      width={'auto'}
                    >
                      {isCreatingPayment && antIcon}
                      {translations?.['b2b.txt.pay-now'] ?? ''}
                    </StyledButton>
                    <div>
                      {ticket.orderInfo.payment?.code !== 'BankTransfer' && (
                        <Countdown
                          onTimeout={() => search?.({})}
                          orderCheckout={ticket}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <StyledButton
                      style={{
                        marginTop: 8,
                        height: 44,
                        minWidth: 171,
                      }}
                      onClick={() =>
                        windowOpenLink({
                          url: `/update-order-info?order_id=${ticket._id}`,
                          target: '_self',
                        })
                      }
                      textColor="white"
                      width={'auto'}
                    >
                      {translations?.['b2b.txt.input-customer-info'] ?? ''}
                    </StyledButton>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Col>
      {isAbleCancelOrder && (
        <>
          <Col span={device === 'mobile' ? 0 : 12}></Col>
          <Col span={12} className="d-flex">
            <CancelOrderComponent
              isExchange={true}
              idHash={ticket?._id ?? ''}
              isDisable={
                (!isSaleMng &&
                  ticket.paymentInfo.email !== infoUser?.username) ||
                (isProxyOrder && !isProxyBuyer)
              }
              onCancelOrderSuccess={onCancelOrderSuccess}
            />
          </Col>
        </>
      )}
    </Row>
  );
};

const Divider = styled(StyledDivider)`
  margin: 11px 0px;
  width: 100%;
`;

export const StringStatus = (status: string) => {
  if (status === '0') return 'UNUSE';
  if (status === '1') return 'USED';
  if (status === '2') return 'OUTDATE';
  if (status === '3') return 'WAITING_CANCEL';
  if (status === '4') return 'CANCELLED';
  if (status === '5') return 'WAITING_REFUND';
  if (status === '6') return 'REFUND_EXPIRED';
  return '';
};
export const listStatus = translations => {
  return [
    {
      id: 0,
      label: translations ? translations['b2b.text.all'] : '',
      value: 'All',
    },
    {
      id: 0,
      label: translations ? translations['b2b.txt.status-unused'] : '',
      value: '0',
    },
    {
      id: 1,
      label: translations ? translations['b2b.txt.status-used'] : '',
      value: '1',
    },
    {
      id: 2,
      label: translations ? translations['b2b.txt.ticket-expired'] : '',
      value: '2',
    },
    {
      id: 3,
      label: translations ? translations['b2b.txt.ticket-pending-cancel'] : '',
      value: '3',
    },
    {
      id: 4,
      label: translations ? translations['b2b.txt.ticket-cancelled'] : '',
      value: '4',
    },
    {
      id: 5,
      label: translations
        ? translations['b2b.txt.ticket-waiting-to-change']
        : '',
      value: '5',
    },
    {
      id: 6,
      label: translations ? translations['b2b.txt.ticket-changed'] : '',
      value: '6',
    },
    {
      id: 7,
      label: translations ? translations['b2b.txt.reissued'] : '',
      value: '7',
    },
  ];
};

export const listOrderTypeStr = translations => {
  return [
    {
      id: 0,
      label: translations ? translations['b2b.txt.order-brandnew'] : '',
      value: 'new',
    },
    {
      id: 1,
      label: translations ? translations['b2b.txt.order-exchange'] : '',
      value: 'upgrade',
    },
    {
      id: 2,
      label: translations ? translations['b2b.txt.order-refund'] : '',
      value: 'return',
    },
  ];
};
export const getDateValidNormal = (
  fromDate: string,
  toDate: string,
  numberDateAddToFrom?: number,
  stringFormat: string = 'DD/MM/YYYY',
  isComboTicket: boolean = false,
  isComboDiffTicket: boolean = false,
) => {
  const standardDayAdd = _.isNil(numberDateAddToFrom) ? 0 : numberDateAddToFrom;
  const addDay = standardDayAdd <= 0 ? 1 : standardDayAdd;
  const fromDateMoment = moment(fromDate, 'HH:mm DD/MM/YYYY');
  const toDateByAddDayMoment = moment(fromDate, 'HH:mm DD/MM/YYYY').add(
    addDay - 1,
    'days',
  );
  const toDateMoment = moment(toDate, 'HH:mm DD/MM/YYYY');
  const standardToDateMoment = toDateByAddDayMoment.isBefore(toDateMoment)
    ? toDateByAddDayMoment
    : toDateMoment;
  return {
    fromDate: fromDateMoment.format(stringFormat),
    toDate:
      isComboTicket && isComboDiffTicket
        ? moment(toDate, 'HH:mm DD/MM/YYYY').format(stringFormat)
        : standardToDateMoment.format(stringFormat),
  };
};

export const getDateRangeCombo = (
  fromDate: string,
  toDate: string,
  stringFormat: string = 'DD/MM/YYYY',
) => {
  const fromDateMoment = moment(fromDate, stringFormat);
  const toDateMoment = moment(toDate, stringFormat);
  return {
    fromDate: fromDateMoment.format(stringFormat),
    toDate: toDateMoment.format(stringFormat),
  };
};

export const convertVItoEN = str => {
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '');
  str = str.replace(/\u02C6|\u0306|\u031B/g, '');
  return str;
};
